import React from 'react';
import { colors } from './constants';

const GradientStatCard = ({ title, value, icon, gradient, subtitle }) => (
  <div className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden transition hover:shadow-lg">
    <div className="h-2" style={{ background: gradient }}></div>
    <div className="p-5">
      <div className="flex items-center mb-1">
        {React.cloneElement(icon, { size: 22, className: "mr-3", style: { color: gradient.startsWith('linear') ? '#FF6B00' : gradient } })}
        <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
      </div>
      <p className="text-3xl font-bold my-3" style={{ color: gradient.startsWith('linear') ? '#FF6B00' : gradient }}>
        {value}
      </p>
      {subtitle && <p className="text-gray-600 text-sm">{subtitle}</p>}
    </div>
  </div>
);

export default GradientStatCard;
